import basicTheme from '../basicTheme.js';

const breadcrumbsStyleOverrides = {
    defaultProps: {
        maxItems: 9999,
    },
    styleOverrides: {
        li: {
            display: 'flex',
            whiteSpace: 'nowrap',
            width: 'fit-content',
            color: basicTheme.palette.N20.main,
            cursor: 'pointer',
            alignItems: 'center',
            height: '20px',
            justifyContent: 'center',
            '&:hover': {
                p: {
                    color: basicTheme.palette.primary.main,
                },
            },
        },
        ol: {
            flexWrap: 'nowrap',
            alignItems: 'center',
        },
        separator: Object.assign({ color: basicTheme.palette.N30.main }, basicTheme.typography.h5),
    },
};

export { breadcrumbsStyleOverrides as default };
//# sourceMappingURL=MuiBreadcrumbs.js.map
